/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/jsx-no-bind */
import { useState } from 'react'

import PropTypes from 'prop-types'

import {
  BADGE_CODE,
  IMAGE_CODE,
  PREVIEW_IMAGE_CODE,
  generatePassportImageStyle,
  getSizedImage,
  isVideo,
} from 'utils/images'

import imagePlaceholder from 'assets/images/icon_image_placeholder.png'

// this import is problematic and collides with imports of Favorites.module
// for some reason
import styles from './Media.component.module.css'

const Media = ({
  mediaSource: PropImageSource,
  overrides,
  className,
  showPlaceholderOnError,
  minPlaceholderWidth,
  maxPlaceholderWidth,
  alt,
  badgeSized,
  previewImageSized,
}) => {
  const [hasLoaded, setHasLoaded] = useState(false)

  const customImageStyle = generatePassportImageStyle(overrides)
  const imageStyle = hasLoaded ? customImageStyle : { display: 'none' }
  let placeholderStyle = { objectFit: 'none', background: '#F8F8F8' }

  if (minPlaceholderWidth) {
    placeholderStyle = {
      ...placeholderStyle,
      minWidth: minPlaceholderWidth,
    }
  }
  if (maxPlaceholderWidth) {
    placeholderStyle = {
      ...placeholderStyle,
      maxWidth: maxPlaceholderWidth,
    }
  }

  const placeholderClassName = className.replace('tw-object-cover', '')

  let mediaSource = PropImageSource
  const mediaIsVideo = isVideo(mediaSource)

  if (!mediaIsVideo && badgeSized) {
    mediaSource = getSizedImage(mediaSource, BADGE_CODE)
  } else if (!mediaIsVideo && previewImageSized) {
    mediaSource = getSizedImage(mediaSource, PREVIEW_IMAGE_CODE)
  } else if (!mediaIsVideo) {
    mediaSource = getSizedImage(mediaSource, IMAGE_CODE)
  }

  if (mediaIsVideo) {
    const videoStyle = {
      width: '100%',
      display: !hasLoaded ? 'none' : false,
    }
    return (
      <div className={styles.videoContainer}>
        {showPlaceholderOnError && !hasLoaded && (
          <img
            src={imagePlaceholder}
            className={className}
            style={placeholderStyle}
            alt="placeholder"
          />
        )}
        <video
          controls
          className={className}
          style={videoStyle}
          loop
          autoPlay
          muted
          onLoadStart={() => setHasLoaded(true)}
        >
          <source src={mediaSource} />
        </video>
      </div>
    )
  }

  return (
    <>
      {showPlaceholderOnError && !hasLoaded && (
        <img
          src={imagePlaceholder}
          className={placeholderClassName}
          style={placeholderStyle}
          alt="placeholder"
        />
      )}
      <img
        src={mediaSource}
        style={imageStyle}
        onLoad={setHasLoaded.bind(this)}
        className={className}
        alt={alt}
      />
    </>
  )
}

Media.propTypes = {
  // The URL of the image or video
  mediaSource: PropTypes.string.isRequired,
  // Custom style overrides used in Passport components
  overrides: PropTypes.shape({
    fillContainer: PropTypes.bool,
    isGrayscale: PropTypes.bool,
    isStyleStory: PropTypes.bool,
  }),
  // Custom style applied to the image or video
  className: PropTypes.string,
  // Determine whether to show a placeholder image during loading and error states
  showPlaceholderOnError: PropTypes.bool,
  // Min width of placeholder image in CSS format (ex. "450px")
  minPlaceholderWidth: PropTypes.string,
  // Max width of placeholder image in CSS format (ex. "650px")
  maxPlaceholderWidth: PropTypes.string,
  // the alternate text for the image
  alt: PropTypes.string,
  // If image should be sized as a badge, else rendered full resolution
  badgeSized: PropTypes.bool,
  // If image should be sized as an image, else rendered full resolution
  previewImageSized: PropTypes.bool,
}

Media.defaultProps = {
  overrides: {
    fillContainer: false,
    isGrayscale: false,
    isStyleStory: false,
  },
  className: '',
  showPlaceholderOnError: true,
  minPlaceholderWidth: '',
  maxPlaceholderWidth: '',
  alt: '',
  badgeSized: false,
  previewImageSized: false,
}

export default Media
